import { Injectable } from '@angular/core';
import {
  UserAccessMenuDto,
  UserAccessChildDto,
  UserAccessSubItemDto,
  UserAccessFavoriteDto,
  UserAccessMenu,
  UserAccessChild,
  UserAccessSubItem,
  FavoriteMenuItem,
} from '../models/system-settings/user-menu.model';

@Injectable({
  providedIn: 'root',
})
export class MapperUserAccessMenuService {
  /** path_id (DB) → Angular route path */
  private readonly menuPathMap: Record<string, string> = {
    '1': '/system-settings/group-menus',
    '2': '/system-settings/group-sub-menus',
    '3': '/system-settings/menu-lists',
    '4': '/dashboard',
    '7': '/system-settings/manage-users',
    '8': '/system-settings/manage-roles',
    '9': '/system-settings/manage-roles-menus',
    '10': '/cityparking/line-oa-member',
    '12': '/parking/transaction-parking',
    '13': '/parking/parking-site',
    '14': '/cityparking/customer-management',
    '15': '/cityparking/ev-charger-list',
    '16': '/parking/parking-cards',
    '17': '/stamp-approve',
    '18': '/coupon-generate',
    '19': '/cityparking/register-member',
    '20': '/vehicle-card-future',
    '21': '/coupon-parking-list',
    '22': '/discount-card',
    '23': '/discount-active',
    '24': '/stamp-discount',
    '25': '/cityparking/vehicle-list',
    '26': '/ev-list',
    '27': '/parking-transaction-ev',
    '28': '/generate-ev-qr',
    '29': '/parking/register-parking',
    '30': '/provider-parking',
    '31': '/provider-site',
    '32': '/provider-group',
    '33': '/provider-spot',
    '34': '/floor-tenant-company',
    '35': '/tenant-company',
    '36': '/parking-type',
    '37': '/parking-zone',
    '38': '/finance/invoice-list',
    '39': '/fine-list',
    '40': '/finance/revenue-add',
    '41': '/report/full-tax-report',
    '42': '/system-settings/setting-quota-card',
    '43': '/system-settings/setting-invoice',
    '44': '/system-settings/setting-invoice-fee',
    '45': '/system-settings/approval-config',
    '46': '/card-quota/quota-requests',
    '47': '/card-quota/client-quotas',
    '48': '/card-quota/quota-allocation',
    '49': '/approval/inbox',
    '50': '/approval/history',
    '51': '/system-settings/setting-card-type-config',
    '52': '/card-quota/platform-cards',
    '53': '/card-quota/quota-card-advances',
    '54': '/finance/manage-fee',
    '55': '/finance/manage-fee-group',
    '56': '/finance/manage-subscription',
    '57': '/cityparking/card-advances',
    '58': '/finance/parking-finance',
    '59': '/cityparking/top-up',
    '60': '/customer-service/customer-service-issue-type',
    '61': '/customer-service/customer-service-case',
    '62': '/system-settings/parking-vehicle-type',
    '63': '/system-settings/parking-card-type',
    '64': '/system-settings/parking-card-mode',
    '65': '/system-settings/parking-payment-log',
    '66': '/system-settings/parking-gate-type',
    '67': '/system-settings/parking-gate',
    '68': '/cityparking/ev-station-monitor',
    '69': '/parking/parking-cards-bulk-dates',
    '70': '/parking/discount/prestamp-taiwan',
    '71': '/cityparking/ev-charging-jobs',
    '72': '/system-settings/ev-price-rates',
    '73': '/system-settings/ev-connector-types',
    '74': '/parking/membership-packages',
    '75': '/system-settings/line-rich-menu',
    '76': '/cityparking/news-management',
    '77': '/cityparking/news-categories',
    '78': '/system-settings/parking-area',
    '79': '/system-settings/parking-gate-group',
    '80': '/system-settings/parking-rate',
    '81': '/finance/parking-shift',
    '82': '/parking/discount/taiwan-discount',
    '83': '/parking/discount/stamp-group',
    '84': '/parking/discount/stamp-amount-map',
    '85': '/parking/discount/stamp-receipt',
    '86': '/system-settings/parking-main-rate',
    '87': '/system-settings/parking-sub-rate',
    '88': '/parking/discount/stamp-members',
    '89': '/system-settings/parking-penalty-rate',
    '90': '/parking/discount/stamp-apply',
    '91': '/parking/discount/stamp-billable-charge',
    '92': '/parking/parking-cards-taiwan-pending',
    '93': '/cityparking/register-member-card',
    '94': '/parking/vehicles-in-parking',
    '95': '/parking/discount/web-stamp-history',
    '96': '/parking/discount/free-range',
    '97': '/report/register-member-payment',
    '98': '/report/rpfi05',
    '99': '/report/rpfi09',
    '100': '/report/rpfi13',
    '101': '/report/rpfi01',
    '102': '/report/rppk01',
    '103': '/report/rpfi15',
    '104': '/dashboard-parking',
    '105': '/dashboard-parking-ops',
    '106': '/dashboard-parking-finance',
    '107': '/report/rpfi26',
    '108': '/report/rppk15',
    '109': '/report/rppk14',
    '110': '/parking/parking-client',
    '111': '/report/rppk16',
    '112': '/parking/local-fee-calc-test',
    '113': '/parking/parking-cards-deleted',
    '114': '/report/rpfi17',
    '115': '/cityparking/register-member-marketing',
    '116': '/finance/revenue-marketing',
    '117': '/system-settings/activity-log',
    '118': '/system-settings/liff-home-menu',
    '119': '/system-settings/site-free-quota',
    // '120': '/system-settings/user-site-access', // ไม่ใช้แล้ว — แทนด้วย access-groups (122); อย่าเลือก path นี้ตอนสร้างเมนู
    '121': '/card-quota/building-free-quota',
    '122': '/system-settings/access-groups',
    '123': '/card-quota/free-parking-dashboard',
    '124': '/card-quota/free-parking-cards',
    '125': '/card-quota/free-parking-advances',
  '126': '/system-settings/line-guide-menu',
  '127': '/system-settings/public-guides',
  '128': '/system-settings/site-public-profiles',
  '129': '/system-settings/line-broadcasts',
  '130': '/finance/bank-accounts',
  };

  /** path_id (DB) → Material icon (used when API does not send icon) */
  private readonly menuIconMap: Record<string, string> = {
    '1': 'grid_view',
    '2': 'class',
    '3': 'menu_book',
    '4': 'grid_view',
    '7': 'person',
    '8': 'shield',
    '9': 'menu_open',
    '10': 'people',
    '12': 'local_parking',
    '13': 'local_parking',
    '14': 'people',
    '15': 'electric_car',
    '16': 'local_parking',
    '17': 'verified',
    '18': 'qr_code',
    '19': 'how_to_reg',
    '20': 'calendar_month',
    '21': 'list_alt',
    '22': 'card_giftcard',
    '23': 'check_circle',
    '24': 'bookmark',
    '25': 'directions_car',
    '26': 'electric_car',
    '27': 'ev_station',
    '28': 'qr_code_2',
    '29': 'app_registration',
    '30': 'business',
    '31': 'domain',
    '32': 'group_work',
    '33': 'local_parking',
    '34': 'corporate_fare',
    '35': 'business_center',
    '36': 'category',
    '37': 'map',
    '38': 'receipt_long',
    '39': 'gavel',
    '40': 'monetization_on',
    '41': 'tax',
    '42': 'confirmation_number',
    '43': 'receipt_long',
    '44': 'payments',
    '45': 'fact_check',
    '46': 'assignment',
    '47': 'confirmation_number',
    '48': 'share',
    '49': 'inbox',
    '50': 'history',
    '51': 'credit_card',
    '52': 'badge',
    '53': 'confirmation_number',
    '57': 'confirmation_number',
    '54': 'price_change',
    '55': 'folder',
    '56': 'subscriptions',
    '58': 'receipt_long',
    '59': 'account_balance_wallet',
    '60': 'type_specimen',
    '61': 'headset_mic',
    '62': 'directions_car',
    '63': 'credit_card',
    '64': 'tune',
    '65': 'receipt_long',
    '66': 'door_front',
    '67': 'sensor_door',
    '68': 'ev_station',
    '69': 'date_range',
    '70': 'confirmation_number',
    '71': 'bolt',
    '72': 'price_change',
    '73': 'ev_station',
    '74': 'subscriptions',
    '75': 'menu',
    '76': 'newspaper',
    '77': 'category',
    '78': 'map',
    '79': 'sensor_door',
    '80': 'payments',
    '81': 'schedule',
    '82': 'local_offer',
    '83': 'groups',
    '84': 'payments',
    '85': 'receipt_long',
    '86': 'account_tree',
    '87': 'functions',
    '88': 'badge',
    '89': 'gavel',
    '90': 'local_offer',
    '91': 'receipt_long',
    '92': 'send',
    '93': 'badge',
    '94': 'directions_car',
    '95': 'history',
    '96': 'event_available',
    '97': 'payments',
    '98': 'summarize',
    '99': 'receipt',
    '100': 'payments',
    '101': 'local_parking',
    '102': 'swap_horiz',
    '103': 'badge',
    '104': 'dashboard',
    '105': 'local_parking',
    '106': 'account_balance',
    '107': 'directions_bus',
    '108': 'schedule',
    '109': 'badge',
    '110': 'store',
    '111': 'card_membership',
    '112': 'calculate',
    '113': 'delete_forever',
    '114': 'approval',
    '115': 'campaign',
    '116': 'account_balance',
    '117': 'history',
    '118': 'apps',
    '119': 'local_parking',
    // '120': 'admin_panel_settings', // unused — see menuPathMap 120
    '121': 'apartment',
    '122': 'groups',
    '123': 'dashboard',
    '124': 'credit_card',
    '125': 'fact_check',
    '126': 'support_agent',
    '127': 'menu_book',
    '128': 'local_parking',
    '129': 'campaign',
    '130': 'account_balance',
  };

  constructor() { }

  /**
   * Resolves Angular route from path_id returned by getUserAccessMenu.
   */
  private resolvePath(pathId: number): string {
    return this.menuPathMap[pathId.toString()] ?? '';
  }

  /**
   * Resolves icon from path_id when API icon is empty.
   */
  private resolveIcon(pathId: number, defaultIcon = 'circle'): string {
    return this.menuIconMap[pathId.toString()] ?? defaultIcon;
  }

  /** LIVE badge for realtime pages */
  private isLivePath(path: string): boolean {
    return path === '/parking/transaction-parking' || path === '/cityparking/ev-charger-list';
  }

  public mapSubItemFromDto(dto: UserAccessSubItemDto): UserAccessSubItem {
    const path = this.resolvePath(dto.pathId);
    return {
      id: dto.id,
      name: dto.name,
      path,
      url: path,
      live: this.isLivePath(path),
      canCreate: dto.canCreate ?? false,
      canUpdate: dto.canUpdate ?? false,
      canDelete: dto.canDelete ?? false,
    };
  }

  public mapChildFromDto(dto: UserAccessChildDto): UserAccessChild {
    const path = this.resolvePath(dto.pathId);
    return {
      id: dto.id,
      name: dto.name,
      icon: dto.icon || this.resolveIcon(dto.pathId, 'circle'),
      path,
      url: path,
      exact: path === '/dashboard',
      live: this.isLivePath(path),
      submenu: dto.submenu
        ? dto.submenu.map((sub) => this.mapSubItemFromDto(sub))
        : undefined,
      expanded: false,
    };
  }

  public mapMenuFromDto(dtos: UserAccessMenuDto[]): UserAccessMenu[] {
    if (!dtos) return [];

    return dtos.map((dto) => ({
      id: dto.id,
      heading: dto.heading || '',
      children: dto.children
        ? dto.children.map((child) => this.mapChildFromDto(child))
        : [],
    }));
  }

  public mapFavoriteFromDto(dtos: UserAccessFavoriteDto[]): FavoriteMenuItem[] {
    if (!dtos) return [];

    return dtos.map((dto) => {
      const path = this.resolvePath(dto.pathId);
      return {
        id: dto.id,
        name: dto.name,
        url: path,
        icon: this.resolveIcon(dto.pathId, 'star'),
        live: this.isLivePath(path),
      };
    });
  }

  /**
   * Retrieves all predefined menu path options mapped from menuPathMap.
   * Newest pathId first so newly registered routes are easy to find.
   */
  public getMenuPathOptions(): { pathId: number; path: string }[] {
    return Object.entries(this.menuPathMap)
      .map(([key, val]) => ({
        pathId: parseInt(key, 10),
        path: val,
      }))
      .sort((a, b) => b.pathId - a.pathId);
  }
}
